import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Reveal from "./Reveal";

export default function BlogCard({ post, index = 0, dark = false }) {
  const date = post.date ? new Date(post.date).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" }) : "";
  return (
    <Reveal delay={(index % 3) * 0.08} className="h-full">
      <Link
        to={`/about/blog/${post.slug}`}
        className={`group flex flex-col h-full border hover:border-cy/50 hover:-translate-y-1 transition-all duration-500 overflow-hidden ${dark ? "border-white/10 bg-[#14151A]" : "border-[#E2E7EF] bg-white"}`}
        data-testid={`blog-card-${post.slug}`}
      >
        {post.image && (
          <div className={`relative aspect-[16/9] overflow-hidden border-b ${dark ? "border-white/10" : "border-[#E2E7EF]"}`}>
            <img src={post.image} alt={post.title} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
          </div>
        )}
        <div className="flex flex-col flex-1 p-7">
          <div className="flex items-center gap-3 text-[10px] font-tech tracking-[0.2em] uppercase">
            <span className="text-cy">{post.category}</span>
            {date && <span className={dark ? "text-white/40" : "text-mist/40"}>{date}</span>}
          </div>
          <h3 className={`font-display font-bold text-lg leading-snug mt-3 group-hover:text-cy transition-colors ${dark ? "text-white" : "text-[#101828]"}`}>
            {post.title}
          </h3>
          <p className={`text-sm leading-relaxed mt-3 line-clamp-3 flex-1 ${dark ? "text-white/60" : "text-mist/65"}`}>{post.excerpt}</p>
          <span className="inline-flex items-center gap-2 text-xs font-bold text-ember mt-5">
            Read article <ArrowRight size={13} className="transition-transform duration-300 group-hover:translate-x-1" />
          </span>
        </div>
      </Link>
    </Reveal>
  );
}
